/* tslint:disable */
/* eslint-disable */
/**
 * Agoda.PropertyOnboarding
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PropertySelectionItem
 */
export interface PropertySelectionItem {
    /**
     * 
     * @type {number}
     * @memberof PropertySelectionItem
     */
    'externalPropertyType': PropertySelectionItemExternalPropertyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PropertySelectionItem
     */
    'id': string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertySelectionItem
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertySelectionItem
     */
    'location': string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertySelectionItem
     */
    'image': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PropertySelectionItem
     */
    'isEntirePlace'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof PropertySelectionItem
     */
    'status': PropertySelectionItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PropertySelectionItem
     */
    'importUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertySelectionItem
     */
    'createdDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PropertySelectionItem
     */
    'campaignId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PropertySelectionItem
     */
    'encryptedEmail': string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum PropertySelectionItemExternalPropertyTypeEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}
/**
    * @export
    * @enum {string}
    */
export enum PropertySelectionItemStatusEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4
}


